module.exports = __webpack_public_path__ + "img/slotmachine.ac2b7abf.png";